module.exports = __webpack_public_path__ + "img/th.4740fc62.png";